<section class="app-for">
  <h2
    class="app-for--tit app-title"
    [appAnimate]="'slideInRight'"
    [speed]="'fast'"
    [aos]="0.2"
    [once]="true"
    [delay]="'100'"
  >
    Zgłoszenie do Loterii Foxy
  </h2>

  <div class="container app-for__con">
    <form
      [formGroup]="form"
      class="app-form"
      [appAnimate]="'slideInUp'"
      [speed]="'fast'"
      [aos]="0.2"
      [once]="true"
      [delay]="'100'"
    >
      <div class="row">
        <div class="col-12">
          <label class="f-label" for="firstname">Imię*</label>
          <input formControlName="firstname" id="firstname" type="text" />
          <app-validate-message [control]="f.firstname" />
        </div>
        <div class="col-12">
          <label class="f-label" for="lastname">Nazwisko*</label>
          <input formControlName="lastname" id="lastname" type="text" />
          <app-validate-message [control]="f.lastname" />
        </div>
        <div class="col-12">
          <label class="f-label" for="email">E-mail*</label>
          <input
            formControlName="email"
            id="email"
            placeholder="Spokojnie, nie będzie spamu"
            type="email"
          />
          <app-validate-message [control]="f.email" />
        </div>
        <div class="col-12">
          <label class="f-label" for="mobile">Nr telefonu*</label>
          <input
            formControlName="mobile"
            id="mobile"
            [mask]="'000 000 000'"
            placeholder="48 ___ – ___ – ___"
            [prefix]="'+48 '"
            type="text"
          />
          <app-validate-message [control]="f.mobile" />
        </div>

        <div class="col-12 app-form__hint">
          <label class="f-label" for="proofOfPurchaseNumber"
            >Nr dowodu zakupu*</label
          >
          <input
            formControlName="proofOfPurchaseNumber"
            id="proofOfPurchaseNumber"
            type="text"
            placeholder="12345678"
          />
          <app-validate-message [control]="f.proofOfPurchaseNumber" />

          <button class="app-form__hint--btn" (click)="onDisplayHintPopup()">
            <img
              ngSrc="assets/images/form/info.svg"
              class="app-form__file__flab__wra--img w-100 h-auto d-block"
              alt="info"
              priority="false"
              height="22"
              width="22"
            />
          </button>
        </div>

        <div class="col-12 app-form__hint">
          <label class="f-label" for="dateOfPurchase">Data zakupu*</label>

          <input
            formControlName="dateOfPurchase"
            bsDatepicker
            [minDate]="minDate"
            [maxDate]="maxDate"
            id="dateOfPurchase"
            placeholder="rrrr-mm-dd"
            [attr.readonly]="true"
            readonly
            aria-readonly="true"
            [bsConfig]="{
              showWeekNumbers: false,
              showPreviousMonth: false,
              dateInputFormat: 'YYYY-MM-DD',
              containerClass: 'theme-dark-blue',
              keepDatesOutOfRules: false,
              isAnimated: true,
              adaptivePosition: true,
              displayOneMonthRange: true,
            }"
          />
          <app-validate-message [control]="f.dateOfPurchase" />

          <button class="app-form__hint--btn" (click)="onDisplayHintPopup()">
            <img
              ngSrc="assets/images/form/info.svg"
              class="app-form__file__flab__wra--img w-100 h-auto d-block"
              alt="info"
              priority="false"
              height="22"
              width="22"
            />
          </button>
        </div>

        <div class="col-12 app-form__hint">
          <label class="f-label" for="nip">NIP sklepu*</label>
          <input
            [mask]="'0000000000'"
            formControlName="nip"
            id="nip"
            inputmode="numeric"
            placeholder="3333444433"
            type="text"
          />
          <app-validate-message [control]="f.nip" />

          <button (click)="onDisplayHintPopup()" class="app-form__hint--btn">
            <img
              alt="info"
              class="app-form__file__flab__wra--img w-100 h-auto d-block"
              height="22"
              ngSrc="assets/images/form/info.svg"
              priority="false"
              width="22"
            />
          </button>
        </div>

        <div class="col-12 app-form__file">
          <label class="f-label app-form__file--lab">
            Dodaj zdjęcie lub skan dowodu zakupu wybranego produktu promocyjnego
            Foxy a oryginał zachowaj, może być potrzebny do odebrania nagrody.*
          </label>
          <p class="app-form__file--p">
            <img
              ngSrc="assets/images/form/info.svg"
              alt="info"
              priority="false"
              height="22"
              width="22"
            />
            <span>
              Wyłącznie pliki jpg lub png o maksymalnej wadze 10 MB.
              <br class="d-none d-md-block" />Aby przyspieszyć proces
              weryfikacji Twojego paragonu
              <br class="d-none d-md-block" />zadbaj, aby zdjęcie było wyraźne i
              czytelne.
            </span>
          </p>
          <label
            class="app-form__file__flab"
            for="imageOfPurchase"
            [draggable]="true"
            (drop)="onDropFile($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            [ngClass]="{
              dragover: isDragOver(),
              invalid:
                form.controls['imageOfPurchase'].touched &&
                form.controls['imageOfPurchase'].invalid,
            }"
          >
            <input
              class="app-form__file__flab--inp"
              #filesInput
              type="file"
              id="imageOfPurchase"
              [multiple]="false"
              [accept]="'.png,.jpg,.jpeg'"
              (change)="handleFileUpload(filesInput.files![0])"
            />
            @if (selectedFile()) {
              <div class="app-form__file__flab__wra">
                <span>
                  {{ selectedFile()?.name }}
                  <img
                    #imageResult
                    src="#"
                    alt="selected file"
                    width="50"
                    height="50"
                    class="d-block h-auto m-auto"
                  />
                </span>
                <span
                  (click)="deleteSelectedFile($event, filesInput)"
                  role="button"
                >
                  <img
                    ngSrc="assets/images/close.svg"
                    class="app-form__file__flab__wra--img"
                    alt="delete file icon"
                    priority="false"
                    height="33"
                    width="33"
                  />
                </span>
              </div>
            } @else {
              <div class="app-form__file__flab__wra">
                <span class="app-form__file__flab__wra--txt d-block d-md-none">
                  Dodaj zdjęcie za pomocą przycisku
                </span>
                <span class="app-form__file__flab__wra--txt d-none d-md-block">
                  Przeciągnij tutaj plik z dysku
                  <br class="d-none d-md-block" />lub dodaj za pomocą przycisku
                </span>
                <img
                  ngSrc="assets/images/form/add.svg"
                  class="app-form__file__flab__wra--img"
                  alt="add file icon"
                  priority="false"
                  height="45"
                  width="45"
                />
              </div>
            }
          </label>

          <app-validate-message [control]="f.imageOfPurchase" />
        </div>

        <div class="col-12">
          <input
            class="checkbox"
            formControlName="consentAdult"
            id="consentAdult"
            name="consentAdult"
            type="checkbox"
          />
          <label
            [ngClass]="{
              error:
                form.controls['consentAdult'].touched &&
                !form.controls['consentAdult'].value,
            }"
            for="consentAdult"
            >Oświadczam, że jestem osobą pełnoletnią i mam ukończone
            18&nbsp;lat.*</label
          >
          <app-validate-message [control]="f.consentAdult" />
        </div>

        <div class="col-12">
          <input
            class="checkbox"
            formControlName="consentRegulations"
            id="consentRegulations"
            type="checkbox"
          />
          <label
            [ngClass]="{
              error:
                form.controls['consentRegulations'].touched &&
                !form.controls['consentRegulations'].value,
            }"
            for="consentRegulations"
          >
            Zapoznałem/-am się z&nbsp;<a
              href="assets/files/regulamin.pdf"
              target="_blank"
            >
              regulaminem </a
            >&nbsp;Loterii i akceptuję jego postanowienia.*
          </label>
          <app-validate-message [control]="f.consentRegulations" />
        </div>

        <div class="col-12">
          <input
            class="checkbox"
            formControlName="consentClause"
            id="consentClause"
            type="checkbox"
          />
          <label
            [ngClass]="{
              error:
                form.controls['consentClause'].touched &&
                !form.controls['consentClause'].value,
            }"
            for="consentClause"
            >Wyrażam zgodę na przetwarzanie moich danych osobowych zawartych w
            formularzu, a także danych określonych Regulaminem a
            potwierdzających spełnienie warunków uczestnictwa w&nbsp;Loterii,
            przez Organizatora Human2Human sp.&nbsp;z&nbsp;o.o. oraz
            ICT&nbsp;POLAND Sp.&nbsp;z&nbsp;o.&nbsp;o.*</label
          >
          <app-validate-message [control]="f.consentClause" />
        </div>

        <div class="col-12">
          <input
            class="checkbox"
            formControlName="consentCommunication"
            id="consentCommunication"
            type="checkbox"
          />
          <label
            [ngClass]="{
              error:
                form.controls['consentCommunication'].touched &&
                !form.controls['consentCommunication'].value,
            }"
            for="consentCommunication"
            >Wyrażam zgodę na prowadzenie ze mną komunikacji w&nbsp;związku
            z&nbsp;Loterią za pomocą środków komunikacji
            elektronicznej/telekomunikacyjnych urządzeń końcowych, których
            jestem użytkownikiem (tj. wiadomości e-mail i sms; urządzeń
            przypisanych do numeru telefonu, z&nbsp;którego korzystam oraz
            adresu e-mail) w&nbsp;celu przesyłania wiadomości związanych
            z&nbsp;moim udziałem w&nbsp;Loterii.*</label
          >
          <app-validate-message [control]="f.consentCommunication" />
        </div>

        <div class="col-12">
          <input
            class="checkbox"
            formControlName="consentExclusion"
            id="consentExclusion"
            type="checkbox"
          />
          <label
            [ngClass]="{
              error:
                form.controls['consentExclusion'].touched &&
                !form.controls['consentExclusion'].value,
            }"
            for="consentExclusion"
            >Oświadczam, że nie należę do grona osób wyłączonych z Loterii, o
            których mowa w § 6 ust. 2.*</label
          >
          <app-validate-message [control]="f.consentExclusion" />
        </div>

        <div class="col-12 mb-4">
          <p class="app-for--sm-lab mb-0">*oświadczenia obowiązkowe</p>
        </div>

        <div
          class="col-12 d-flex justify-content-center align-items-center mb-3"
        >
          <button
            (click)="onRegister()"
            class="app-for--btn"
            type="submit"
            appGtmClick
            [layer]="{
              allow_custom_scripts: true,
              u1: 'https://loteriafoxy.pl',
              u2: 'WYŚLIJ ZGŁOSZENIE I PRZEJDŹ DO E-ZDRAPKI',
              u50: '',
              send_to: 'DC-13117613/licz/lote-kli+standard',
            }"
          >
            WYŚLIJ ZGŁOSZENIE I PRZEJDŹ <br />
            DO E-ZDRAPKI
          </button>
        </div>
        <div class="col-12 text-center">
          <a class="app-for--reg" href="assets/files/regulamin.pdf" download
            >POBIERZ REGULAMIN ></a
          >
        </div>
      </div>
    </form>
  </div>
</section>
